import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import BaseButton from "@/components_v2/Button/BaseButton";
import { BUTTON_TYPES } from "@/components_v2/Button/constants";
import { selectCurrentUser } from "@/redux/authentication/selectors";
import { Roles } from "@/shared/utils/constants";

const CompleteProfileBanner = () => {
  const { t } = useTranslation();
  const currentUser = useSelector(selectCurrentUser);

  if (!currentUser || currentUser.role === Roles.ADMIN.value) return null;

  const { profile } = currentUser;
  const isIncomplete =
    !profile.jobTitle ||
    !profile.department ||
    !profile.city ||
    !profile.country ||
    !profile.honorific ||
    profile.areasOfExpertise.length === 0;

  if (!isIncomplete) return null;

  return (
    <div className="onboarding-actions-card flex flex-col gap-100">
      <p className="body-m-medium">{t("banners.completeProfile.title")}</p>

      <p className="body-s-regular">
        {t("banners.completeProfile.description")}
      </p>

      <BaseButton type={BUTTON_TYPES.LINK} to={`/users/${currentUser.id}`}>
        {t("banners.completeProfile.action")}
      </BaseButton>
    </div>
  );
};

export default CompleteProfileBanner;
